var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureRank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 208,
    viewBox: "0 0 217 208",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261162909",
    filter: "url(#filter0_d_3654_3750)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6835 54.062L108.419 8.02235V0.205078L21.936 50.1533L28.6835 54.062Z",
    fill: "url(#paint0_radial_3654_3750)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.421 8.02235L188.198 54.062L194.946 50.1533L108.421 0.205078V8.02235Z",
    fill: "url(#paint1_radial_3654_3750)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3669 19.7493L108.422 12.7961V8.02344L28.686 54.063L32.8004 56.4494L63.987 38.4696L96.3669 19.7493Z",
    fill: "url(#paint2_radial_3654_3750)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.421 12.7961L146.232 34.6021L184.043 56.4494L188.198 54.063L108.421 8.02344V12.7961Z",
    fill: "url(#paint3_radial_3654_3750)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6835 146.144V54.0649L21.936 50.1562V150.053L28.6835 146.144Z",
    fill: "url(#paint4_radial_3654_3750)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.686 54.0645V146.144L32.8004 143.757V100.104V56.4508L28.686 54.0645Z",
    fill: "url(#paint5_radial_3654_3750)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.042 83.2352V100.104V143.757L188.198 146.144V54.0645L184.042 56.4508V83.2352Z",
    fill: "url(#paint6_radial_3654_3750)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.197 54.0649V146.144L194.944 150.053V50.1562L188.197 54.0649Z",
    fill: "url(#paint7_radial_3654_3750)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.6111 165.603L56.0463 157.169L32.8004 143.756L28.686 146.142L108.422 192.182V187.409L70.6111 165.603Z",
    fill: "url(#paint8_radial_3654_3750)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.419 192.183L28.6835 146.144L21.936 150.052L108.419 200V192.183Z",
    fill: "url(#paint9_radial_3654_3750)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.816 175.066L108.421 187.409V192.182L188.198 146.142L184.043 143.756L162.237 156.346L146.232 165.603L129.816 175.066Z",
    fill: "url(#paint10_radial_3654_3750)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.198 146.144L108.421 192.183V200L194.946 150.052L188.198 146.144Z",
    fill: "url(#paint11_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.419 0.123433V7.9407L28.6835 54.0626L21.936 49.9482C30.8641 49.9482 38.9694 46.451 58.3068 34.972L77.2739 24.0278C96.8992 13.0014 104.017 7.77613 108.419 0V0.123433Z",
    fill: "url(#paint12_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.043 143.756L188.157 146.142L108.421 192.182V187.574C112.536 189.219 118.543 184.529 138.045 173.297L157.012 162.353C176.514 151.079 183.138 147.911 184.043 143.756Z",
    fill: "url(#paint13_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3521 29.4183L107.517 7.44769L108.422 1.0293L109.327 7.44769L120.395 14.8947L108.422 9.13458L71.3521 29.4183Z",
    fill: "url(#paint14_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.091 173.338L188.2 147.212L194.207 149.639L189.105 145.648L188.2 121.826L187.213 145.566L141.091 173.338Z",
    fill: "url(#paint15_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7985 32.6289L28.6872 52.9949L22.6392 50.5675L27.7821 54.5584L28.6872 107.14L29.6746 54.5996L65.7985 32.6289Z",
    fill: "url(#paint16_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.7985 167.58L28.6872 147.214L22.6392 149.642L27.7821 145.651L28.6872 117.509L29.6746 145.569L65.7985 167.58Z",
    fill: "url(#paint17_radial_3654_3750)"
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.686 100.1L21.9385 81.627L4 100.1L21.9385 118.574L28.686 100.1Z",
    fill: "#F56D00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.686 100.1L21.9385 81.627L4 100.1H28.686Z",
    fill: "url(#paint18_radial_3654_3750)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.686 100.103L21.9385 118.576L4 100.103H28.686Z",
    fill: "url(#paint19_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1247 97.3075C13.0104 98.9532 8.6492 99.4469 7.08575 96.9372L4 100.105H28.686L25.8471 92.3291C25.3534 94.0983 20.4574 96.032 17.1247 97.3075Z",
    fill: "url(#paint20_radial_3654_3750)"
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5519 31.0254L81.1829 15.9257L56.2089 9.67188L49.1733 34.3991L68.5519 31.0254Z",
    fill: "#F56D00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5518 31.0254L81.1827 15.9257L56.2087 9.67188L68.5518 31.0254Z",
    fill: "url(#paint21_radial_3654_3750)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5519 31.0254L49.1733 34.3991L56.2089 9.67188L68.5519 31.0254Z",
    fill: "url(#paint22_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2193 19.6286C61.6399 16.7486 59.089 13.3748 60.4879 10.7416L56.3735 9.67188L62.9565 21.0275L68.7165 31.0254L73.8595 24.8127C72.0903 25.2653 67.9759 22.0149 65.2193 19.752V19.6286Z",
    fill: "url(#paint23_radial_3654_3750)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.33 31.0254L167.709 34.3991L160.673 9.67188L135.699 15.9257L148.33 31.0254Z",
    fill: "#F56D00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.331 31.0254L167.71 34.3991L160.674 9.67188L148.331 31.0254Z",
    fill: "url(#paint24_radial_3654_3750)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.33 31.0254L135.699 15.9257L160.673 9.67188L148.33 31.0254Z",
    fill: "url(#paint25_radial_3654_3750)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.197 100.1L194.944 81.627L212.883 100.1L194.944 118.574L188.197 100.1Z",
    fill: "#F56D00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.197 100.1L194.944 81.627L212.883 100.1H188.197Z",
    fill: "url(#paint26_radial_3654_3750)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.197 100.103L194.944 118.576L212.883 100.103H188.197Z",
    fill: "url(#paint27_radial_3654_3750)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.33 169.141L167.709 165.768L160.673 190.536L135.699 184.241L148.33 169.141Z",
    fill: "#F56D00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.331 169.141L167.71 165.768L160.674 190.536L148.331 169.141Z",
    fill: "url(#paint28_radial_3654_3750)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.33 169.143L135.699 184.242L160.673 190.537L148.33 169.143Z",
    fill: "url(#paint29_radial_3654_3750)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5519 169.141L81.1829 184.241L56.2089 190.536L49.1733 165.768L68.5519 169.141Z",
    fill: "#F56D00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5518 169.143L81.1827 184.242L56.2087 190.537L68.5518 169.143Z",
    fill: "url(#paint30_radial_3654_3750)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.5519 169.141L49.1733 165.768L56.2089 190.536L68.5519 169.141Z",
    fill: "url(#paint31_radial_3654_3750)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8003 143.757L108.422 187.41L184.043 143.757V56.4501L108.422 12.7969L32.8003 56.4501V143.757Z",
    fill: "#0EC89C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.423 162.519L162.526 131.332V68.8764L108.423 37.6484L54.3604 68.8764V131.332L108.423 162.519Z",
    fill: "#00FFC3"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.581 14.4418L108.42 8.02344L111.3 14.4418V32.6684L108.42 34.6844L105.581 32.6684V14.4418Z",
    fill: "#F56D00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.202 54.7639L188.197 54.0645L184.041 59.7423L168.242 68.8761L165.074 67.3949L165.362 63.8978L181.202 54.7639Z",
    fill: "#F56D00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.041 140.423L188.197 146.142L181.202 145.401L165.362 136.267L165.074 132.811L168.242 131.33L184.041 140.423Z",
    fill: "#F56D00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.581 185.765L108.42 192.183L111.3 185.765V167.497L108.42 165.522L105.581 167.497V185.765Z",
    fill: "#F56D00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8415 140.423L28.686 146.142L35.6804 145.401L51.5206 136.267L51.7675 132.811L48.6405 131.33L32.8415 140.423Z",
    fill: "#F56D00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6804 54.7639L28.686 54.0645L32.8415 59.7423L48.6405 68.8761L51.7675 67.3949L51.5206 63.8978L35.6804 54.7639Z",
    fill: "#F56D00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7409 127.794V72.3732L32.8003 59.7422L32.8414 140.425L40.7409 127.794Z",
    fill: "url(#paint32_radial_3654_3750)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7397 72.3732V127.793L48.6393 131.332V68.876L40.7397 72.3732Z",
    fill: "url(#paint33_radial_3654_3750)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8003 59.7422L40.7409 72.3732L48.6405 68.876L32.8003 59.7422Z",
    fill: "url(#paint34_radial_3654_3750)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8003 140.424L40.7409 127.793L48.6405 131.331L32.8003 140.424Z",
    fill: "url(#paint35_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1985 61.9648L39.8763 72.9913L40.7403 95.7025L41.3575 73.197L46.4181 69.8644L40.946 71.6747L34.1985 61.9648Z",
    fill: "url(#paint36_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1985 138.243L39.8763 127.217L40.7403 114.668L41.3575 127.011L46.4181 130.344L40.946 128.533L34.1985 138.243Z",
    fill: "url(#paint37_radial_3654_3750)"
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.311 144.865L118.297 172.596L111.302 185.762L181.205 145.4L166.311 144.865Z",
    fill: "url(#paint38_radial_3654_3750)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.297 172.598L166.311 144.868L165.365 136.269L111.302 167.496L118.297 172.598Z",
    fill: "url(#paint39_radial_3654_3750)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.302 185.763L118.297 172.597L111.302 167.495V185.763Z",
    fill: "url(#paint40_radial_3654_3750)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.203 145.402L166.31 144.868L165.363 136.269L181.203 145.402Z",
    fill: "url(#paint41_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.536 183.461L119.242 173.01L138.497 160.914L118.666 171.653L113.235 168.896L117.555 172.763L112.536 183.461Z",
    fill: "url(#paint42_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.611 145.32L166.227 145.896L154.913 151.45L165.281 144.744L165.651 138.654L166.803 144.332L178.611 145.32Z",
    fill: "url(#paint43_radial_3654_3750)"
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5893 172.596L50.575 144.865L35.6812 145.4L105.584 185.762L98.5893 172.596Z",
    fill: "url(#paint44_radial_3654_3750)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5757 144.868L98.59 172.598L105.584 167.496L51.522 136.269L50.5757 144.868Z",
    fill: "url(#paint45_radial_3654_3750)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6812 145.402L50.575 144.868L51.5214 136.269L35.6812 145.402Z",
    fill: "url(#paint46_radial_3654_3750)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.584 185.763L98.5896 172.597L105.584 167.495V185.763Z",
    fill: "url(#paint47_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2727 145.32L50.6568 145.896L70.7759 156.552L51.6031 144.744L51.2328 138.654L50.0808 144.332L38.2727 145.32Z",
    fill: "url(#paint48_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.347 183.461L97.6411 173.011L87.1907 166.017L98.2171 171.653L103.648 168.897L99.328 172.764L104.347 183.461Z",
    fill: "url(#paint49_radial_3654_3750)"
  }), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.143 127.794V72.3732L184.043 59.7422V140.425L176.143 127.794Z",
    fill: "url(#paint50_radial_3654_3750)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.143 72.3732V127.793L168.244 131.332V68.876L176.143 72.3732Z",
    fill: "url(#paint51_radial_3654_3750)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.043 59.7422L176.143 72.3732L168.244 68.876L184.043 59.7422Z",
    fill: "url(#paint52_radial_3654_3750)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.043 140.424L176.143 127.793L168.244 131.331L184.043 140.424Z",
    fill: "url(#paint53_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.685 61.9648L177.008 72.9913L176.144 95.7025L175.526 73.197L170.466 69.8644L175.938 71.6747L182.685 61.9648Z",
    fill: "url(#paint54_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.685 138.243L177.008 127.217L176.144 114.668L175.526 127.011L170.466 130.344L175.938 128.533L182.685 138.243Z",
    fill: "url(#paint55_radial_3654_3750)"
  }), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5893 27.6112L50.575 55.3008L35.6812 54.766L105.584 14.4453L98.5893 27.6112Z",
    fill: "url(#paint56_radial_3654_3750)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5757 55.297L98.59 27.6074L105.584 32.6681L51.522 63.896L50.5757 55.297Z",
    fill: "url(#paint57_radial_3654_3750)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6812 54.7646L50.575 55.2995L51.5214 63.8985L35.6812 54.7646Z",
    fill: "url(#paint58_radial_3654_3750)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.584 14.4453L98.5896 27.6112L105.584 32.6719V14.4453Z",
    fill: "url(#paint59_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2727 54.8865L50.6568 54.2693L70.7759 43.6543L51.6031 55.4625L51.2328 61.5106L50.0808 55.8739L38.2727 54.8865Z",
    fill: "url(#paint60_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.347 16.7461L97.6411 27.1554L87.1907 34.1909L98.2171 28.5543L103.648 31.2698L99.328 27.4434L104.347 16.7461Z",
    fill: "url(#paint61_radial_3654_3750)"
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.311 55.3008L118.297 27.6112L111.302 14.4453L181.205 54.766L166.311 55.3008Z",
    fill: "url(#paint62_radial_3654_3750)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.297 27.6074L166.311 55.297L165.365 63.896L111.302 32.6681L118.297 27.6074Z",
    fill: "url(#paint63_radial_3654_3750)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.302 14.4453L118.297 27.6112L111.302 32.6719V14.4453Z",
    fill: "url(#paint64_radial_3654_3750)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.203 54.7646L166.31 55.2995L165.363 63.8985L181.203 54.7646Z",
    fill: "url(#paint65_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.536 16.7461L119.242 27.1554L138.497 39.2516L118.666 28.5543L113.235 31.2698L117.555 27.4434L112.536 16.7461Z",
    fill: "url(#paint66_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.611 54.8844L166.227 54.2673L154.913 48.7129L165.281 55.4604L165.651 61.5085L166.803 55.8719L178.611 54.8844Z",
    fill: "url(#paint67_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.6021 38.0988C66.4946 38.5103 68.1816 42.9126 67.3998 45.5869L85.0503 35.3834C84.2447 34.0345 83.7989 32.5014 83.7557 30.9309C83.7124 29.3604 84.0732 27.8051 84.8035 26.4141L64.6021 38.0988Z",
    fill: "url(#paint68_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.743 156.47C159.974 156.922 154.214 154.824 153.514 152.355L137.921 161.325C140.554 161.777 144.175 165.192 143.64 167.167L161.743 156.47Z",
    fill: "url(#paint69_radial_3654_3750)"
  }), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.423 37.6484L162.526 68.8764V131.332L108.423 162.519L54.3604 131.332V68.8764L108.423 37.6484Z",
    fill: "#0068FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6189 81.7132L88.0157 78.2982L99.7827 71.5096L108.423 63.322V37.6484L81.3916 53.283L54.3604 68.8764L76.6189 81.7132Z",
    fill: "url(#paint70_radial_3654_3750)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.421 63.322L117.103 71.5096L128.87 78.2982L140.266 81.7132L162.525 68.8764L135.494 53.283L108.421 37.6484V63.322Z",
    fill: "url(#paint71_radial_3654_3750)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.267 81.7128L137.551 93.3152V106.893L140.267 118.495L162.525 131.332V100.104V68.876L140.267 81.7128Z",
    fill: "url(#paint72_radial_3654_3750)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.266 118.492L128.87 121.907L117.103 128.696L108.421 136.842V162.516L135.494 146.922L162.525 131.329L140.266 118.492Z",
    fill: "url(#paint73_radial_3654_3750)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.423 136.842L99.7827 128.696L88.0157 121.907L76.6189 118.492L54.3604 131.329L81.3916 146.922L108.423 162.516V136.842Z",
    fill: "url(#paint74_radial_3654_3750)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.6189 118.495L79.3344 106.893V93.3152L76.6189 81.7128L54.3604 68.876V100.104V131.332L76.6189 118.495Z",
    fill: "url(#paint75_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.365 97.7587C142.365 92.1632 161.99 73.0726 162.525 88.0489V68.876L145.574 78.6681L142.365 92.1632V97.7587Z",
    fill: "url(#paint76_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8376 54.7642C83.4457 54.7642 87.272 68.5884 86.5726 73.5668L98.3396 66.7781C95.4184 63.8158 93.5669 46.2064 102.001 41.3926L78.8376 54.7642Z",
    fill: "url(#paint77_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.707 135.898C147.548 135.405 143.064 134.664 136.563 124.296L132.449 125.612L123.685 130.591C128.252 133.759 136.975 142.934 134.341 147.707L154.913 135.816L154.707 135.898Z",
    fill: "url(#paint78_radial_3654_3750)"
  }), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.542 66.7773L132.242 74.6769L142.364 92.1629V108.003L132.242 125.53L118.542 133.43H98.3403L84.5984 125.53L74.5183 108.003V92.1629L84.5984 74.6769L98.3403 66.7773H118.542Z",
    fill: "url(#paint79_radial_3654_3750)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3403 66.7758L108.42 57.2305L118.542 66.7758H98.3403Z",
    fill: "url(#paint80_radial_3654_3750)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.244 74.6777L145.574 78.6687L142.365 92.1637L132.244 74.6777Z",
    fill: "url(#paint81_radial_3654_3750)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.365 108.003L145.574 121.539L132.244 125.53L142.365 108.003Z",
    fill: "url(#paint82_radial_3654_3750)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3403 133.433L108.42 142.978L118.542 133.433H98.3403Z",
    fill: "url(#paint83_radial_3654_3750)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.517 108.003L71.3079 121.539L84.5972 125.53L74.517 108.003Z",
    fill: "url(#paint84_radial_3654_3750)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.5972 74.6777L71.3079 78.6687L74.517 92.1637L84.5972 74.6777Z",
    fill: "url(#paint85_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5789 116.766L108.42 100.103L79.5789 83.4395L74.5183 92.1619V108.002L79.5789 116.766Z",
    fill: "url(#paint86_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.5808 83.4405L108.422 100.104V66.7773H98.3422L84.6003 74.6769L79.5808 83.4405Z",
    fill: "url(#paint87_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.421 66.7773V100.104L137.304 83.4405L132.243 74.6769L118.543 66.7773H108.421Z",
    fill: "url(#paint88_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_105",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.304 83.4395L108.421 100.103L137.304 116.766L142.365 108.002V92.1619L137.304 83.4395Z",
    fill: "url(#paint89_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_106",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.304 116.766L108.421 100.103V133.429H118.543L132.243 125.529L137.304 116.766Z",
    fill: "url(#paint90_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_107",
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.422 133.429V100.103L79.5808 116.766L84.6003 125.529L98.3422 133.429H108.422Z",
    fill: "url(#paint91_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_108",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4708 129.481L98.3417 134.09C101.386 136.954 104.142 140.109 106.57 143.511C107.746 148.809 108.366 154.214 108.422 159.64C108.499 154.192 109.092 148.765 110.191 143.429C110.433 142.82 110.766 142.251 111.179 141.742L114.758 137.011L110.644 139.479C110.008 139.884 109.253 140.058 108.504 139.973C105.628 138.973 103.195 136.992 101.633 134.378L106.365 133.431L99.3703 132.896L91.4297 129.481H91.4708Z",
    fill: "url(#paint92_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_109",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4697 70.7262L98.3407 65.9536C101.375 63.0801 104.13 59.9253 106.569 56.5317C107.738 50.8998 108.358 45.1677 108.421 39.416C108.5 45.1761 109.092 50.9178 110.19 56.5729C110.431 57.1951 110.764 57.7776 111.177 58.3009L114.757 63.0324L110.643 60.5226C110.013 60.1049 109.252 59.9295 108.503 60.0289C107.021 60.4983 105.65 61.2661 104.476 62.285C103.301 63.3039 102.347 64.5524 101.673 65.9536L106.405 66.8999L99.4104 67.4348L91.4697 70.8497V70.7262Z",
    fill: "url(#paint93_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_110",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4712 70.7239L84.0654 74.3446C80.0422 75.563 75.9073 76.3762 71.7224 76.772C66.5381 75.1303 61.534 72.966 56.7874 70.3125C61.5678 73.0669 66.061 76.2922 70.2001 79.9401C71.5722 82.1959 72.6899 84.5969 73.5327 87.099C73.5327 85.2476 72.9978 81.7093 74.0676 80.2281C76.3076 78.1637 79.2502 77.0308 82.2962 77.06L80.7328 81.6681L84.8471 75.8669L91.7592 70.7239H91.4712Z",
    fill: "url(#paint94_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_111",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M142.363 100.103L142.898 108.331C143.875 112.407 145.253 116.376 147.012 120.181C150.631 123.672 154.65 126.724 158.985 129.273C154.594 126.785 149.945 124.785 145.119 123.307C144.479 123.204 143.826 123.204 143.186 123.307L137.302 124.048L141.416 121.785C142.09 121.437 142.626 120.871 142.939 120.181C143.517 117.181 143.006 114.074 141.499 111.417L138.331 115.038L141.334 108.702L142.363 100.144V100.103Z",
    fill: "url(#paint95_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_112",
    style: {
      mixBlendMode: "multiply"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.4558 128.286C84.6009 125.529 58.1869 132.935 70.9825 140.917L54.5251 131.33L71.4762 121.538L84.7655 125.652L89.6204 128.409L89.4558 128.286Z",
    fill: "url(#paint96_radial_3654_3750)"
  }), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_113",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7659 67.3924L108.42 34.6833V31.0215L48.6389 65.582L51.7659 67.3924Z",
    fill: "url(#paint97_radial_3654_3750)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_114",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.419 34.6875L51.7649 67.3966L54.3569 68.8778L108.419 37.6498V34.6875Z",
    fill: "url(#paint98_radial_3654_3750)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_115",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.421 34.6833L165.076 67.3924L168.244 65.582L108.421 31.0215V34.6833Z",
    fill: "url(#paint99_radial_3654_3750)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_116",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.076 67.3966L108.421 34.6875V37.6498L162.525 68.8778L165.076 67.3966Z",
    fill: "url(#paint100_radial_3654_3750)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_117",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.3569 131.33V68.8737L51.7649 67.3926V132.811L54.3569 131.33Z",
    fill: "url(#paint101_radial_3654_3750)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_118",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7659 132.813V67.3953L48.6389 65.585V134.624L51.7659 132.813Z",
    fill: "url(#paint102_radial_3654_3750)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_119",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.527 68.8737V131.33L165.077 132.811V67.3926L162.527 68.8737Z",
    fill: "url(#paint103_radial_3654_3750)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_120",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.074 67.3953V132.813L168.242 134.624V65.585L165.074 67.3953Z",
    fill: "url(#paint104_radial_3654_3750)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_121",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.419 162.517L54.3569 131.33L51.7649 132.811L108.419 165.52V162.517Z",
    fill: "url(#paint105_radial_3654_3750)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_122",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.42 165.522L51.7659 132.812L48.6389 134.623L108.42 169.142V165.522Z",
    fill: "url(#paint106_radial_3654_3750)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_123",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.525 131.33L108.421 162.517V165.52L165.076 132.811L162.525 131.33Z",
    fill: "url(#paint107_radial_3654_3750)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_124",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.076 132.812L108.421 165.522V169.142L168.244 134.623L165.076 132.812Z",
    fill: "url(#paint108_radial_3654_3750)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_125",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.581 14.4418L108.42 8.02344V34.6844L105.581 32.6684V14.4418Z",
    fill: "url(#paint109_radial_3654_3750)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_126",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.301 14.4418L108.421 8.02344V34.6844L111.301 32.6684V14.4418Z",
    fill: "url(#paint110_radial_3654_3750)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_127",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.202 54.7639L188.197 54.0645L165.074 67.3949L165.362 63.8978L181.202 54.7639Z",
    fill: "url(#paint111_radial_3654_3750)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_128",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.041 59.7423L188.197 54.0645L165.074 67.3949L168.242 68.8761L184.041 59.7423Z",
    fill: "url(#paint112_radial_3654_3750)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_129",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.041 140.423L188.197 146.142L165.074 132.811L168.242 131.33L184.041 140.423Z",
    fill: "url(#paint113_radial_3654_3750)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_130",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.202 145.402L188.197 146.143L165.074 132.812L165.362 136.269L181.202 145.402Z",
    fill: "url(#paint114_radial_3654_3750)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_131",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.581 185.765L108.42 192.183V165.522L105.581 167.497V185.765Z",
    fill: "url(#paint115_radial_3654_3750)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_132",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.301 185.765L108.421 192.183V165.522L111.301 167.497V185.765Z",
    fill: "url(#paint116_radial_3654_3750)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_133",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8415 140.423L28.686 146.142L51.7675 132.811L48.6405 131.33L32.8415 140.423Z",
    fill: "url(#paint117_radial_3654_3750)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_134",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6804 145.402L28.686 146.143L51.7675 132.812L51.5206 136.269L35.6804 145.402Z",
    fill: "url(#paint118_radial_3654_3750)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_135",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6804 54.7639L28.686 54.0645L51.7675 67.3949L51.5206 63.8978L35.6804 54.7639Z",
    fill: "url(#paint119_radial_3654_3750)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_136",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.8415 59.7423L28.686 54.0645L51.7675 67.3949L48.6405 68.8761L32.8415 59.7423Z",
    fill: "url(#paint120_radial_3654_3750)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_137",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.063 56.2438L107.228 33.8617L108.421 14.8945L109.573 33.9028L126.401 45.0527L108.421 35.7543L71.063 56.2438Z",
    fill: "url(#paint121_radial_3654_3750)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_138",
    style: {
      mixBlendMode: "screen"
    },
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.077 89.6533L166.394 132.196L182.234 142.687L165.201 134.171L147.098 143.181L164.131 132.278L165.077 89.6533Z",
    fill: "url(#paint122_radial_3654_3750)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3654_3750",
    x: 0,
    y: 0,
    width: 216.883,
    height: 208,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3654_3750"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3654_3750",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.761 -2.22239) scale(106.191 106.191)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.505 -34.5201) scale(127.833 127.833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.966 50.8538) scale(87.5942 87.5946)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(144.586 -17.4033) scale(192.51 192.511)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-75.2034 85.622) scale(152.313 152.313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.858 98.4583) scale(129.56 129.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.19 102.984) scale(136.636 136.638)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.345 83.8116) scale(142.398 142.398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(111.837 116.971) scale(117.547 117.547)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.863 114.874) scale(144.495 144.496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.767 176.218) scale(102.406 102.406)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(110.067 105.494) scale(118.205 118.205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9832 -4.32007) scale(80.3941 80.3944)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(131.215 142.604) scale(67.5163 67.5165)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD58C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.744 1.72874) scale(59.2876 59.2878)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(192.191 148.405) scale(96.8927 96.893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3546 40.9399) scale(63.9779 63.9782)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9696 143.1) scale(58.3412 58.3415)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.1875 105.202) scale(56.4076 56.4077)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.06756 62.0859) scale(63.2785 63.2788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8653 109.075) scale(34.5193 34.5194)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.4889 7.49127) scale(61.0567 61.057)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77.5212 -4.15235) scale(78.7074 78.7076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.7759 5.22837) scale(41.9662 41.9664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(135.824 11.441) scale(54.8852 54.8855)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.178 -13.4096) scale(59.3288 59.329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(214.117 117.669) scale(83.9736 83.9739)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(153.307 59.823) scale(72.5769 72.5772)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(128.541 196.666) scale(57.148 57.1484)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.05 166.633) scale(50.5653 50.5654)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED8700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A12D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0611 146.226) scale(63.443 63.4433)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D64F00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(81.5532 206.87) scale(70.7667 70.7669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB6600"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5638 70.3572) scale(80.6818 80.6824)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9238 68.3411) scale(87.7999 87.8003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7409 74.6361) scale(41.7604 41.7607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.3179 94.0964) scale(47.9731 47.9733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.6454 70.1524) scale(35.4245 35.4246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8031 125.448) scale(33.1204 33.1205)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(125.085 88.2517) scale(101.912 101.913)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(155.449 135.528) scale(99.6492 99.6496)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.402 162.023) scale(46.6565 46.6568)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.24 144.127) scale(31.886 31.8862)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(121.464 176.96) scale(35.7537 35.7537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(159.932 143.057) scale(37.9754 37.9755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(101.099 170.621) scale(83.1096 83.1099)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(95.2163 172.31) scale(59.4111 59.4112)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4426 145.114) scale(44.0646 44.0647)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(82.955 159.513) scale(40.4854 40.4853)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5083 144.579) scale(34.0255 34.0257)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.5177 164.906) scale(28.7592 28.7593)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(157.67 63.8154) scale(76.8969 76.8972)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(179.764 73.1549) scale(78.5838 78.5841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(178.406 75.3767) scale(19.8311 19.8312)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.698 107.674) scale(40.3205 40.3207)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(174.292 67.3135) scale(30.0758 30.0759)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.605 123.432) scale(28.9238 28.9239)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.112 34.8936) scale(125.199 125.2)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.359 35.1778) scale(111.622 111.622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4105 54.5589) scale(80.3531 80.3533)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.154 3.17199) scale(52.8285 52.8283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1506 55.7916) scale(39.045 39.0452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.2708 27.5257) scale(29.4586 29.4588)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.93 24.69) scale(112.074 112.075)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.268 27.2371) scale(62.2499 62.2501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.803 22.7974) scale(66.0761 66.0765)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(163.964 30.9014) scale(34.8072 34.8074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0077F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0043C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(119.859 27.8137) scale(45.3401 45.3402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.297 51.1404) scale(31.1867 31.1868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8857 40.0326) scale(62.5791 62.5793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.536 139.313) scale(33.0792 33.0794)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(103.691 63.8569) scale(86.1542 86.1546)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.653 81.2194) scale(79.8182 79.8184)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(127.718 73.6486) scale(65.8295 65.8296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.971 84.9602) scale(118.411 118.411)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.265 144.289) scale(81.0113 81.0116)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050EB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92.1712 69.4931) scale(72.0833 72.0835)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172.07 108.991) scale(41.7195 41.7195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(98.9567 70.0696) scale(86.5243 86.5248)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(132.284 119.606) scale(36.2473 36.2474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(94.5963 68.3408) scale(86.6067 86.6071)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#36A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0049FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(97.3529 42.8302) scale(52.7458 52.746)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(154.297 54.97) scale(42.748 42.7481)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(145.698 120.799) scale(52.3345 52.3345)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#217CFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.715 124.587) scale(50.6064 50.6065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2795FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.9124 124.337) scale(58.3001 58.3003)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3BB2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0068FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.0211 75.3772) scale(77.6786 77.679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CC3FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.84368 118) scale(111.334 111.334)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(85.1763 5.59694) scale(104.422 104.422)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(143.27 44.6421) scale(66.0351 66.0353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(160.18 59.2882) scale(74.5518 74.5521)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(147.549 161.489) scale(111.375 111.376)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(87.3158 151.409) scale(72.8237 72.8241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(107.146 136.764) scale(41.2668 41.267)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(102.537 56.2849) scale(37.2348 37.2349)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(76.2482 72.452) scale(35.3833 35.3834)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.107 121.25) scale(45.34 45.3402)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5CE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.8136 166.714) scale(54.1858 54.1861)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#ECF1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#D4E0F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#B2C8E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#87A9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5282C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106.692 49.2069) scale(72.4535 72.4537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.766 100.887) scale(103.681 103.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(133.066 15.963) scale(89.9806 89.9809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.287 24.7719) scale(82.3279 82.3282)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.27023 93.4776) scale(117.668 117.67)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.0524 81.5898) scale(95.1247 95.1238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(148.127 91.585) scale(90.3501 90.3512)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(130.184 92.3694) scale(83.8507 83.8505)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(114.673 96.6461) scale(99.2377 99.2382)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.535 102.819) scale(101.583 101.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(146.602 147.088) scale(86.4011 86.4014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.868 115.45) scale(86.8126 86.8129)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.078 34.9313) scale(28.1827 28.1833)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(93.0746 22.0945) scale(33.6147 33.6143)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(182.19 39.5408) scale(52.5812 52.5814)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(164.786 74.0602) scale(35.9593 35.9594)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165.321 132.318) scale(44.3525 44.3527)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(167.008 133.224) scale(29.6643 29.6645)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(108.337 166.757) scale(27.0307 27.0313)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(109.861 166.962) scale(25.8385 25.8381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4509 131.536) scale(27.8541 27.8542)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF8C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC521"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.4543 132.689) scale(36.3296 36.3297)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9767 64.8852) scale(54.1858 54.186)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E67D2D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3916 60.1537) scale(43.9411 43.9413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.801 31.5988) scale(68.7506 68.7508)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_3654_3750",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(166.188 133.224) scale(65.9116 65.9119)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEF8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureRank);
export default __webpack_public_path__ + "static/media/azureRank.2a4c356a84c8e17fc322a70f9aef38df.svg";
export { ForwardRef as ReactComponent };